import { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext(null);

/**
 * Light-Mode-Only ThemeProvider.
 *
 * Decision (Feb 2026, user feedback): Dark Mode wurde komplett deaktiviert, weil
 * die Kontraste auf der Landingpage und in den Cards unleserlich waren und User
 * abgeschreckt hat. Wir erzwingen Light Mode auf jedem Render und entfernen
 * etwaige alte `dark`-Klassen vom <html>-Element.
 *
 * Die API (theme/mode/toggleTheme/setTheme) bleibt als No-Op erhalten, damit
 * existierende Komponenten (Layout, Settings, sonner) nicht brechen.
 */
export const ThemeProvider = ({ children }) => {
    useEffect(() => {
        const root = document.documentElement;
        root.classList.remove('dark');
        root.style.colorScheme = 'light';
        try {
            // Alte Persistenz wegräumen, damit kein "system"/"dark" mehr greift
            localStorage.removeItem('wellness_theme_mode');
        } catch { /* storage may be unavailable */ }
    }, []);

    const value = {
        theme: 'light',
        mode: 'light',
        setTheme: () => {},
        toggleTheme: () => {},
    };

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
